// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDzzp1rzu2ue1eX0YK2kfKPnyHFA_5mCVA",
  authDomain: "msz-web-e9fc3.firebaseapp.com",
  projectId: "msz-web-e9fc3",
  storageBucket: "msz-web-e9fc3.firebasestorage.app",
  messagingSenderId: "62989918774",
  appId: "1:62989918774:web:45db72663b9bbd27e36e97",
  measurementId: "G-3M3V351660",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
